import { UiFloatPopover } from "../../../common/popover";

type TemplateOptions = Readonly<{
    title: string;
    desc: string;
    primaryText?: string;
    secondaryText?: string;
}>;

const getTemplate = ({
    title,
    desc,
    primaryText,
    secondaryText,
}: TemplateOptions): string => `
<style>  
    .popup-wrapper {
        padding: 10px;
        min-width: 400px;
        display: flex;
        flex-direction: column;
        gap: 8px;
    } 

    .popup-title {
        margin: 0;
    }

    .popup-content-confirm {
        display: flex;
        align-items: center;
        gap: 4px;
    }

    .popup-footer {
        display: flex;
        justify-content: end;
        gap: 10px;
    }

    #close-icon {
        cursor: pointer;
    }

    #edit button {
      color: #fff;
      background: #345AA4;
    }
 
</style>

<div class="popup" style="background: #fff; max-width: 500px">
    <div class="popup-wrapper">
        <h3 class="popup-title">${title ?? ""}</h3>

        <div class="popup-content-confirm"> 
            <span>${desc ?? ""}</span>
        </div>
        
        <div class="popup-footer">
            <fw-button id="primary" color="primary"> ${
                primaryText ?? "Ок"
            } </fw-button>
            <fw-button id="secondary" color="secondary"> ${
                secondaryText ?? "Отмена"
            } </fw-button>
        </div>
    </div> 
</div>
`;

type Options = Readonly<{
    position: {
        x: number;
        y: number;
    };
    onConfirm: () => void;
    onCancel?: () => void;
    title: string;
    description: string;
    parent?: HTMLElement;
}>;

/**
 * Shows confirmation popup.
 * @param options Options.
 */
export function showConfirmationPopup(options: Options): void {
    setTimeout(() => {
        const popover = new UiFloatPopover(
            getTemplate({
                title: options.title,
                desc: options.description,
            }),
            {
                x: options.position.x,
                y: options.position.y,
            },
            undefined,
            undefined,
            undefined,
            options.parent,
        );

        popover.root.querySelector("#primary")?.addEventListener("click", () => {
            options.onConfirm();
            popover.destroy();
        });

        popover.root.querySelector("#secondary")?.addEventListener("click", () => {
            options.onCancel?.();
            popover.destroy();
        });
    }, 0);
}
